import { createI18n } from 'vue-i18n';
import enUS from "./en-US";
import zhCN from "./zh-CN";

type MessageSchema = typeof zhCN;


const i18nInstance = createI18n<[MessageSchema], 'zh-CN' | 'en-US'>({
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages:{
    'en-US': enUS,
    'zh-CN': zhCN,
  },
  legacy: false,
});

export const _ = {
  ...i18nInstance.global
} as any;

export const { t, tc, d, tm, locale } = _;

export default i18nInstance;
